import { Record } from "immutable";
import { imageFromJSON, ImageRecord } from "common/records/Image";
import { Nullable } from "common/types";
import { checkDate } from "common/helpers/Date";
import { DateStringNumber } from ".";

export const toolFromJSON = (json: Partial<IToolData>): ToolRecord => {
  const data: IToolRecord = { ...(json as any) };

  if (json.brand_image) {
    data.brand_image = imageFromJSON(json.brand_image);
  } else {
    data.brand_image = imageFromJSON({});
  }

  if (json.updated_at) data.updated_at = checkDate(json.updated_at);
  if (json.created_at) data.created_at = checkDate(json.created_at);

  return new ToolRecord(data);
};

export const toJSON = (record: ToolRecord): IToolData => {
  const tool = record.toJSON() as any;

  if (tool.id <= 0) {
    delete tool.id;
  }

  return tool as IToolData;
};

export const toFormData = (record: IToolData): any => {
  const data = new FormData();
  if (record.id > 0) {
    data.set("tool[id]", record.id as any);
  }
  data.set("tool[name]", record.name);
  data.set("tool[link]", record.link);
  data.set("tool[kind]", record.kind);
  data.set("tool[org_id]", record.org_id as any);
  if (record.brand_image) {
    if (record.brand_image.id > 0 && record.brand_image._destroy) {
      data.set("tool[brand_image_attributes][id]", record.brand_image.id.toString());
      data.set("tool[brand_image_attributes][_destroy]", record.brand_image._destroy.toString());
    } else if (record.brand_image.file_queue) {
      data.set("tool[brand_image_attributes][file]", record.brand_image.file_queue);
    }
  }
  return data;
};

export interface IToolData {
  id: number;
  brand_image?: any;
  name: string;
  link: string;
  kind: string;
  org_id: Nullable<number>;

  loading?: boolean;
  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface IToolRecord {
  id: number;
  brand_image: Nullable<ImageRecord>;
  name: string;
  link: string;
  kind: string;
  org_id: Nullable<number>;

  loading: boolean;
  created_at: Date;
  updated_at: Date;
}

const defaultToolProps: IToolRecord = {
  id: 0,
  brand_image: null,
  name: "",
  link: "",
  kind: "",
  org_id: null,

  loading: false,
  created_at: new Date(),
  updated_at: new Date(),
};

export class ToolRecord extends Record(defaultToolProps) implements IToolRecord {}

export const TOOL_VALUES = [
  "renoworks_masking",
  "eagleview_order",
  "google_maps",
  "bing_ortho",
  "bing_birdseye",
  "zoom_earth",
  "terra_server",
  "pictometry_online",
  "pictometry_connect",
  "map_developers_area",
  "zillow",
  "trulia",
  "greensky_link",
  "chi_overhead_door",
  "homeguard",
  "houzz_link",
  "sketchup",
  "global_transport_link",
  "service_finance_link",
  "foundation_finance_link",
  "foundation_finance_dealer_link",
  "ami_design_showcase_siding",
  "ami_design_showcase_pres_window",
  "ami_design_showcase_alside_window",
  "sighten_solar",
  "enerbank_link",
  "pella_portal",
  "eagleview_order_decra",
  "provia",
  "provia_non_portal",
  "advisar_link",
  "square_d_link",
  "lp_smartside_link",
  "york_hvac_link",
  "sigler_online_link",
  "hearth_financing_link",
  "sherwin_williams_colorsnap",
  "wellsfargo_link",
  "angies_list_link",
  "home_advisor_link",
  "gaf_quick_measure_link",
  "gaf_smart_money_link",
  "timbertech_worry_less",
  "gaf_vhr_link",
  "gaf_vent_calc_link",
  "lowes_deck_designer",
  "thermatru_design_your_door",
  "pella_lowes_product_designer",
];

export const DESIGN_TOOL_VALUES = [
  "ca_3d_demo",
  "oc_design_eyeq",
  "gaf_vhr",
  "daltile_demo",
  "abbeycarpet_demo",
  "provia",
  "provia_non_portal",
  "plygem_visualizer",
  "renuit_cabinet_demo",
  "colorview",
  "alside_renoworks",
  "lp_smartside_visualizer",
  "sunrise_configurator",
  "royal_homeplay",
  "iko_roof_viewer",
  "square_d_ezsel",
  "paragon_visualizer",
  "timbertech_deck_designer",
  "lowes_deck_designer",
  "thermatru_design_your_door",
  "pella_lowes_product_designer",
];
